<template>
    <v-card rounded="lg" class="bg-white py-4 px-5">
		<p class="text-uppercase text-h4">ERROR SCOPE</p>
		<p class="">
		Error code mendeskripsikan tentang tingkat kesalahan / error.</p>
		<!-- <div class="col-md-8 ps-0">			
			<v-simple-table class="border-primary">
				<template v-slot:default>
					<tbody>
						<tr>
							<td>Key</td>
							<td>Value</td>
						</tr>
						<tr>
							<td>Authorization</td>
							<td>Bearer {api_key}</td>
						</tr>
					</tbody>
				</template>
			</v-simple-table>
		</div> -->
    </v-card>
</template>

<script>
export default {
    setup() {
        return {
        };
    },
};
</script>
